export const goalPillars = {
    1: {
        title: 'Making choices and planning my life',
        description: 'I got support to make my own decisions and plan the things I want to do.',
        subtitle: '(Support for making choices and plans)'
    },
    2: {
        title: 'Getting support through changes in my life',
        description: 'I got help when things in my life changed, like moving home or starting something new.',
        subtitle: '(Support for making transitions and progression)'
    },
    3: {
        title: 'Being part of my community',
        description: 'I got support to join in with local activities and feel included where I live.',
        subtitle: '(Support for inclusion in one’s local community)'
    },
    4: {
        title: 'Learning new things',
        description: 'I got help to go to school, college or other places to learn and build skills.',
        subtitle: '(Support for accessing education and formal learning)'
    },
    5: {
        title: 'Becoming more independent',
        description: 'I got support to do more things on my own and feel more confident.',
        subtitle: '(Support for maximising independence)'
    },
    6: {
        title: 'Growing as a person and making friends',
        description: 'I got help to try new things, meet people, and build my confidence.',
        subtitle: '(Support for personal and social development)'
    },
    7: {
        title: 'Looking after my health and wellbeing',
        description: 'I got support to feel well in my body and mind.',
        subtitle: '(Support for health and wellbeing)'
    },
    8: {
        title: 'Getting ready for work or training',
        description: 'I got support to prepare for work or training I might want to do.',
        subtitle: '(Support for accessing bridging programmes to vocational training)'
    },
    9: {
        title: 'Doing work or training that’s right for me',
        description: 'I got help to find a job, volunteer, or take part in meaningful training.',
        subtitle: '(Support for accessing vocational training and work opportunities)'
    },
    10: {
        title: 'Being creative and showing who I am',
        description: 'I got the chance to enjoy things like art, music, writing or other hobbies that express who I am.',
        subtitle: '(Support for personal expression and creativity)'
    },
    11: {
        title: 'Having a role that matters',
        description: 'I was supported to be someone who helps, belongs, and makes a difference.',
        subtitle: '(Support for having meaningful social roles)'
    },
    12: {
        title: 'Having a say and being heard',
        description: 'I got support to speak up and share my views, and to be listened to.',
        subtitle: '(Support for influencing service policy and practice)'
    }
};
